import api from '@/logic/api'

export default {
  getCompetitions: () => api.get('/competitions'),
  findCompetition: (id) => api.get(`/competitions/${id}`),
  hasRequiredCredentials: () => api.get('/competitions/hasRequiredCredentials'),
}
